export const isExternalLink = (href: string) => {
  try {
    const url = new URL(href);
    return url.protocol.startsWith('http') && url.origin !== location.origin;
  } catch (_error) {
    return false;
  }
};

export const fixExternalLinks = () => {
  document.querySelectorAll('a').forEach((link) => {
    const isAction = link.classList.contains('leaf-u-link--action');
    const isExternal = isExternalLink(link.href);
    if (link.href && isExternal && !isAction) {
      link.classList.add('leaf-u-link--external');
      link.setAttribute('rel', 'noopener');
      link.setAttribute('target', '_blank');
    }
  });
};
